export default __webpack_public_path__ + "static/media/button_wrong.7d104da6.png";